export const PARSE_ID = process.env.REACT_APP_PARSE_ID || '';
export const PARSE_KEY = process.env.REACT_APP_PARSE_KEY || '';
export const PARSE_SERVER_URL = process.env.REACT_APP_PARSE_SERVER_URL || '';
export const PARSE_MASTER_KET = process.env.REACT_APP_PARSE_MASTER_KET || '';
